import approvedIcon from "../../assets/icons/approved.png";
import reprovedIcon from "../../assets/icons/reproved.png";

import styles from "./CardDotGrid.module.css";
import GradeCard from "./GradeCard/GradeCard";

function CardDotGrid({
	approved = "default",
	grades,
	finalGrade,
	maxGrade,
	approvedText = "Aprovado",
	reprovedText = "Reprovado",
	customColorFunction = false,
	showIcon = true,
}) {
	function defaultColorStyle(approved) {
		if (approved === "default") {
			return null;
		} else if (approved) {
			return styles.approved;
		} else {
			return styles.reproved;
		}
	}

	const colorStyle = customColorFunction
		? customColorFunction(approved)
		: defaultColorStyle(approved);
	const mainCardStyles = [styles.mainCard, colorStyle].join(" ");
	const finalGradeStyles = [styles.finalValue, colorStyle].join(" ");
	const badgeStyles = [styles.badge, colorStyle].join(" ");
	return (
		<div className={styles.container}>
			<div className={mainCardStyles}>
				<div className={styles.finalLabel}>Nota final</div>
				<div className={finalGradeStyles}>
					{typeof finalGrade === "number" && finalGrade.toFixed(2)}{" "}
					{typeof finalGrade === "number" ? "/" : "-"}
                    {" "}{typeof finalGrade === "number" && maxGrade.toFixed(2)}
				</div>
				<div className={badgeStyles}>
					{approved !== "default" && showIcon && (
						<img
							src={approved ? approvedIcon : reprovedIcon}
							alt={approved ? approvedText : reprovedText}
						/>
					)}
					{approved ? approvedText : reprovedText}
				</div>
			</div>
			<div className={styles.cardGrid}>
				{grades &&
					grades.map(({ title, grade, max_grade }) => (
						<GradeCard
							key={`${title}-grade`}
							subject={title}
							grade={grade}
							maxGrade={max_grade}
						/>
					))}
			</div>
		</div>
	);
}

export default CardDotGrid;
